/* Logic media slot: renders the configured asset, or a restrained internal
   placeholder (slate + antique gold) with asset key, use, and aspect ratio.
   Assets uploaded later through admin appear here without code changes. */
export function LogicImage({ media, assetKey, className = "", ratio = "aspect-[3/2]", alt = "" }) {
  const m = media?.[assetKey];
  if (m?.fileUrl) {
    return (
      <img
        src={m.fileUrl}
        alt={alt || m.altText || ""}
        loading="lazy"
        data-testid={`logic-asset-${assetKey}`}
        className={`block w-full h-full object-cover ${className}`}
      />
    );
  }
  return (
    <div
      data-testid={`logic-slot-${assetKey}`}
      role="img"
      aria-label={m?.intendedLocation || assetKey}
      className={`w-full ${ratio} flex flex-col items-center justify-center gap-2 border border-[#c8a95a]/25 bg-[#232b3a] text-center px-6 ${className}`}
    >
      <span className="text-[10px] tracking-[0.3em] uppercase text-[#c8a95a]/80 font-mono">{assetKey}</span>
      <span className="text-xs text-slate-300/70 max-w-sm">{m?.intendedLocation || ""}</span>
      <span className="text-[10px] text-slate-400/60">{m?.aspectRatio || ""}</span>
    </div>
  );
}

export function GeometricEye({ media, size = 40, className = "" }) {
  const m = media?.["logic-02-geometric-eye"];
  if (m?.fileUrl) {
    return <img src={m.fileUrl} alt="" aria-hidden width={size} height={size} className={`rounded-full object-cover ${className}`} style={{ width: size, height: size }} />;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden className={className}>
      <circle cx="20" cy="20" r="18" fill="none" stroke="#c8a95a" strokeWidth="1" opacity="0.7" />
      <path d="M4 20 Q20 8 36 20 Q20 32 4 20 Z" fill="none" stroke="#c8a95a" strokeWidth="1.2" />
      <circle cx="20" cy="20" r="5" fill="#c8a95a" opacity="0.85" />
    </svg>
  );
}

export const STATUS_LABELS = {
  none: "Not Entered", active: "In Practice", ready: "Ready to Continue",
  renew: "Requires Further Practice", done: "Completed",
};
